/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import MUIDataTable from "mui-datatables";
import theme from "../Themes/Theme";
import { Vocabulary } from "../Utils/Vocabulary";
import Config from "../Utils/Config";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { urlEnum } from "../Utils/UrlEnum";
import requestWithoutToken from "../Utils/RequestWithoutToken";

type StateProps = {
  data: any[];
  count: number;
  perPage: number;
  page: number;
  search: string | null;
};
export default function OrdersForCustomer() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [state, setState] = useState<StateProps>({
    data: [],
    count: 0,
    perPage: 10,
    page: 0,
    search: null,
  });

  useEffect(() => {
    const items = location.pathname.split("/");
    const customerId: string = items[items.length - 1];
    getOrders(customerId);
  }, []);

  /**
   *
   */
  async function getOrders(customerId: string) {
    const res = await requestWithoutToken.get(
      `${urlEnum.ordersWithoutToken}/ordersForCustomer/${customerId}`
    );
    if (res && res.data) {
      setState({
        ...state,
        data: res.data.result || [],
        count: res.data.count || 0,
      });
    }
  }

  const ordersHeader = [
    {
      label: Vocabulary.orderReference,
      name: "orderNumber",
      options: {
        sort: true,
      },
    },
    {
      label: Vocabulary.device,
      name: "device",
      options: {
        sort: true,
        customBodyRender: (value: any) => {
          return <>{value?.name || ""}</>;
        },
      },
    },
    {
      label: Vocabulary.status,
      name: "status",
      options: {
        sort: true,
        customBodyRender: (value: any) => {
          return <>{value?.name || ""}</>;
        },
      },
    },
  ];
  /**
   *
   * @param name
   * @param value
   */
  const addParamToQueryString = (name: any, value: any) => {
    searchParams.set(name, value);
    setSearchParams(searchParams);
  };

  /**
   *
   * @param name
   * @param value
   */
  const removeParamFromQueryString = (name: any) => {
    name.map((param: any) => searchParams.delete(param));
    setSearchParams(searchParams);
  };

  /**
   *
   * @returns
   */
  const getTableOptions = () => {
    const responsive: "standard" | "vertical" | "simple" | undefined =
      "standard";
    return {
      selectableRows: "none" as any,
      viewColumns: true,
      responsive: responsive,
      rowsPerPageOptions: Config.rowsPerPage,
      confirmFilters: true,
      filter: false,
      print: false,
      download: false,
      expandableRows: false,
      expandableRowsHeader: false,
      textLabels: {
        body: {
          noMatch: Vocabulary.noResultsFound,
        },
        pagination: {
          next: Vocabulary.nextPage,
          previous: Vocabulary.previousPage,
          rowsPerPage: Vocabulary.rowsPerPage,
          displayRows: Vocabulary.of,
        },
        toolbar: {
          search: Vocabulary.search,
          downloadCsv: Vocabulary.downloadCSV,
          print: Vocabulary.print,
        },
        selectedRows: {
          text: Vocabulary.rowsSelected,
          delete: Vocabulary.delete,
        },
      },
      count: state.count,
      rowsPerPage: state.perPage,
      page: state.page,
      search: true,
      serverSide: true,
      onSearchChange: async (search: string | null) => {
        setState({ ...state, search: search });
        addParamToQueryString("search", search);
      },
      onSearchClose: async () => {
        removeParamFromQueryString(["search"]);
      },
      onChangePage: (page: any) => {
        addParamToQueryString("page", page);
        window.scrollTo(0, 0);
      },
      onChangeRowsPerPage: (numberOfRows: any) => {
        addParamToQueryString("page", 0);
        addParamToQueryString("perPage", numberOfRows);
        window.scrollTo(0, 0);
      },
    };
  };
  return (
    <>
      <div
        style={{
          width: "100vw",
          backgroundColor: theme.palette.primary?.main,
          boxShadow:
            "0px 2px 1px -1px rgb(255 255 255  / 20%), 0px 1px 1px 0px rgb(175 175 175  / 14%), 0px 1px 13px 5px rgb(0 0 0 / 12%)",
        }}
      >
        <img
          style={{ height: 70, marginLeft: 50 }}
          src="/logo.png"
          alt="Icon"
        />
      </div>
      <div style={{ padding: 15 }}>
        <MUIDataTable
          title={Vocabulary.orders}
          data={state.data}
          columns={ordersHeader}
          options={getTableOptions()}
        />
      </div>
    </>
  );
}
